import { CreditCard, Banknote, Smartphone } from "lucide-react";

interface PaymentMethodLabelProps {
  /** 'cod' | 'online' */
  paymentMethod: string;
  /** 'card' | 'wallet' | null — from payment record */
  paymentMethodDetail?: string | null;
  /** 'Visa' | 'Mastercard' | null */
  cardBrand?: string | null;
  /** Last 4 digits */
  cardLastFour?: string | null;
  /** Icon size class */
  iconSize?: string;
}

export const PaymentMethodLabel = ({
  paymentMethod,
  paymentMethodDetail,
  cardBrand,
  cardLastFour,
  iconSize = "w-3.5 h-3.5",
}: PaymentMethodLabelProps) => {
  if (paymentMethod === "cod") {
    return (
      <span className="inline-flex items-center gap-1">
        <Banknote className={iconSize} />
        COD
      </span>
    );
  }

  if (paymentMethodDetail === "wallet") {
    return (
      <span className="inline-flex items-center gap-1">
        <Smartphone className={iconSize} />
        Wallet
      </span>
    );
  }

  if (paymentMethodDetail === "card") {
    return (
      <span className="inline-flex items-center gap-1">
        <CreditCard className={iconSize} />
        {cardBrand || "Card"}
        {cardLastFour && (
          <span className="text-gray-400 font-mono">
            •••• {cardLastFour}
          </span>
        )}
      </span>
    );
  }

  // Online but no detail yet (awaiting payment)
  return (
    <span className="inline-flex items-center gap-1">
      <CreditCard className={iconSize} />
      Online
    </span>
  );
};
